import React, {useState} from 'react';

import {Button, EditIcon} from '@kit';

import {useCharacter} from '../../character-context';
import {ChoiceField} from '../../master/choice-field';
import type {ChoiceInstance} from '../../model/feature-tree';
import {spellManagementTabs, spellPreparations} from '../../model/spell-list';
import {isPreparedOnSheet} from '../../model/spell-preparation';
import {SpellManagement} from '../spell-management';

import css from '../sheet.module.css';

/** что можно поменять после Долгого отдыха: подготовленные заклинания и выборы с пометкой change: longRest */
export const LongRestChanges: React.FC = () => {
	const {catalog, character} = useCharacter();
	const [isManagingSpells, setManagingSpells] = useState(false);
	const featureOf = (choice: ChoiceInstance) => character.getFeatureInstance(choice.featureKey)?.feature;

	const changeable = character.choices.filter((choice) => choice.group.change === 'longRest');
	/** выбор на момент открытия окна: от него считается, сколько вариантов уже заменено */
	const [originalSelection] = useState(() =>
		Object.fromEntries(changeable.map((choice) => [choice.key, choice.selected])),
	);
	const preparedSpells = changeable.filter((choice) => isPreparedOnSheet(choice, featureOf(choice)));
	const otherChoices = changeable.filter((choice) => !preparedSpells.includes(choice));
	if (!preparedSpells.length && !otherChoices.length) return null;

	const byFeature = new Map<string, ChoiceInstance[]>();
	for (const choice of otherChoices) {
		byFeature.set(choice.featureKey, [...(byFeature.get(choice.featureKey) || []), choice]);
	}

	return (
		<>
			<h3 className={css.groupTitle}>Можно поменять после отдыха</h3>
			{preparedSpells.length > 0 && (
				<p>
					<Button icon={<EditIcon />} onClick={() => setManagingSpells(true)}>
						Изменить подготовленные заклинания
					</Button>
				</p>
			)}
			{[...byFeature].map(([featureKey, choices]) => (
				<section key={featureKey} className={css.restChoice}>
					<h4 className={css.restChoiceTitle}>
						{featureOf(choices[0])?.title}
						{choices[0].owner.classId && (
							<span className={css.muted}> · {catalog.getClass(choices[0].owner.classId)?.title}</span>
						)}
					</h4>
					{choices.map((choice) => (
						<ChoiceField
							key={choice.key}
							choice={choice}
							originalSelection={originalSelection[choice.key]}
						/>
					))}
				</section>
			))}
			{isManagingSpells && (
				<SpellManagement
					open
					tabs={spellManagementTabs(spellPreparations(catalog, character), character)}
					onClose={() => setManagingSpells(false)}
				/>
			)}
		</>
	);
};
